// extracted by mini-css-extract-plugin
export var contentBody = "_ay-9";
export var headerImage = "_ay-2";
export var imageButton = "_ay-7";
export var imageButtonIcon = "_ay-8";
export var imageHeader = "_ay-4";
export var imageHeaderText = "_ay-5";
export var imageOverlay = "_ay-3";
export var imageTitle = "_ay-6";
export var imageWrapper = "_ay-1";
export var taskList = "_ay-a";
export var widget = "_ay-0";